import { mapPrice, mapReducedPrice } from "../price";
import { mapBadgeType } from "./mapBadge";
import { insertIntoArray } from "./insertIntoArray";
import { setTileIds } from "./setTileIds";
import { setSponsoredProductRanks } from "../../setSponsoredProductRanks";

export const mapAndInsertProducts = ({
  existingProducts,
  existingExtraItemCount,
  pageSize,
  offset,
  products,
  pageNumber,
  itemCount,
  insertionIndex,
  sponsoredCampaignId
}) => {
  let newProducts = products.map(product => {
    const isSponsored = product.sponsoredCampaignId !== null;

    return {
      id: product.id,
      url: product.url,
      price: mapPrice(product.price),
      description: product.name,
      image: product.imageUrl,
      badgeType: mapBadgeType(product),
      productType: product.productType,
      colourWayId: product.colourWayId,
      isSale: product.price.isMarkedDown,
      reducedPrice: mapReducedPrice(product.price),
      hasMultiplePrices: product.hasMultiplePrices,
      isSponsored,
      isOutlet: product.price.isOutletPrice,
      isSellingFast: product.isSellingFast,
      pageNumber,
      sponsoredCampaignId: isSponsored ? sponsoredCampaignId : null
    };
  });

  const existingItemCount = existingProducts.length;
  const newItemCount = existingItemCount + newProducts.length;
  const maxIndicatedByApi = itemCount - offset.initial;
  const totalExpected = Math.min(
    existingItemCount + pageSize,
    maxIndicatedByApi + existingExtraItemCount
  );
  const extraItemCount =
    existingExtraItemCount + (newItemCount - totalExpected);

  newProducts = insertIntoArray({
    existingProducts,
    newProducts,
    insertionIndex
  });
  setTileIds(newProducts);
  newProducts = setSponsoredProductRanks(newProducts, offset.lower);

  return { products: newProducts, extraItemCount };
};
